import axios from "axios";
import { noTenant } from "./AuthHeader";
import { env } from "../config/env";

const apiUrl = env.API_URL;

class PlanService {
  validate(identificador) {
    return axios.get(apiUrl + "/plano-assinatura/ativo/" + identificador, {
      headers: {
        ...noTenant(),
      },
    });
  }
  search() {
    return axios.get(apiUrl + "/plano-assinatura", {
      headers: {
        ...noTenant(),
      },
    });
  }
  searchPlan(user, valor) {
    return axios.get(apiUrl + `/plano-assinatura/${user}/{valor}?valor=${valor}`, {
      headers: {
        ...noTenant(),
      },
    });
  }
  createPlan(payload) {
    return axios.post(apiUrl + `/plano-assinatura`, payload, {
      headers: {
        ...noTenant(),
      },
    });
  }
  consulta(payload) {
    return axios.post(apiUrl + "/teleconferencia-safeweb/consultar-cpf", payload, {
      headers: {
        ...noTenant(),
      },
    });
  }
  videoconferencia(payload) {
    return axios.post(apiUrl + "/teleconferencia-safeweb/agendar-teleconferencia", payload, {
      headers: {
        ...noTenant(),
      },
    });
  }
}

export default new PlanService();
